export default "__VITE_ASSET__C6M15uTt__"